import {
  contactResponseSchema,
  type ContactRequest,
  type ContactResponse,
} from "@openings/api-contract";
import { BaseHttpClient, baseOk, type ApiOk } from "./base";

const successResponse = baseOk(contactResponseSchema);

export type ContactResult = ApiOk<ContactResponse>;

export class ContactClient extends BaseHttpClient {
  send(input: ContactRequest): Promise<ContactResult> {
    return this.post<ContactResult>("/v1/contact", input, successResponse);
  }
}
